export const AUTH_RESET_CONFIRMATION_ROUTE = '/auth/reset/confirmation';
export const AUTH_RESET_ROUTE = '/auth/reset';
export const AUTH_ROUTE = '/auth';
export const AUTH_SIGN_IN_ROUTE = '/auth/sign-in';
export const AUTH_SIGN_OUT_ROUTE = '/sign-out';
export const AUTH_SIGN_UP_CONFIRMATION_ROUTE = '/auth/sign-up/confirmation';
export const AUTH_SIGN_UP_ROUTE = '/auth/sign-up';
